/**
 * Intercepts 401 responses from the API and redirects to `/login`.
 *
 * Displays a toast to explain the redirect. Mount once inside a
 * `<ToastProvider>` (similar to `<RateLimitInterceptor />`).
 */

import { useToastContext } from "@/components/ui/Toast";
import { t } from "@/i18n";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function StaleSessionInterceptor() {
  const { show } = useToastContext();
  const navigate = useNavigate();

  useEffect(() => {
    const original = window.fetch;

    window.fetch = async (...args: Parameters<typeof fetch>) => {
      const res = await original(...args);

      if (res.status === 401) {
        show(t("session.expired"), "error");
        navigate("/login");
      }

      return res;
    };

    return () => {
      window.fetch = original;
    };
  }, [show, navigate]);

  return null;
}
